/**
 * @generated SignedSource<<04a766263eab622e96c1b797b9925614>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type issuesDropdownNewsletterArticleArticleConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly entityId: string;
      readonly entityUuid: string;
      readonly publishedDate: number | null;
      readonly urlAlias: string;
    };
  }>;
  readonly " $fragmentType": "issuesDropdownNewsletterArticleArticleConnection";
};
export type issuesDropdownNewsletterArticleArticleConnection$key = {
  readonly " $data"?: issuesDropdownNewsletterArticleArticleConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"issuesDropdownNewsletterArticleArticleConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "issuesDropdownNewsletterArticleArticleConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Article",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityUuid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publishedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlAlias",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArticleConnection",
  "abstractKey": null
};

(node as any).hash = "7126eeb595488d42a44fc066b44f02a8";

export default node;
